module.exports = __webpack_public_path__ + "img/shabake.283b56fe.jpg";